import { type Store } from "vuex"

export default function createPlugin(logrocket: {
  log: (name: string, sanitized: unknown) => void,
}, sanitizer = (action => action)) {
  return (store: Store<unknown>) => {
    store.subscribe(mutation => {
      const sanitized = sanitizer(mutation)

      if (sanitized) {
        logrocket.log('[MUTATION]', sanitized)
      }
    })

    store.subscribeAction(action => {
      const sanitized = sanitizer(action)

      if (sanitized) {
        logrocket.log('[ACTION]', sanitized)
      }
    })
  }
}
